import script from "./Agenda.vue?vue&type=script&setup=true&lang=ts"
export * from "./Agenda.vue?vue&type=script&setup=true&lang=ts"

import "./Agenda.vue?vue&type=style&index=0&id=7a29d45d&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\ProntuarioWeb\\FrontEnd\\front-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a29d45d"]])

export default __exports__